// Kill switch for the team invite-LINK UI: the "Invite your team" panel in the
// owner's Store Admin section and the "Send an invite" mode in the staff
// console's StorePeople. Accepting lives at /invite/:token (views/AcceptInvite).
// Set to false to hide the invite-link UI again; adding a person by phone
// (AddPersonForm) is unaffected.
export const INVITE_LINKS_LIVE = true;
